import { CompetitionWithId } from "../interfaces/ICompetitions";
import { findCompetitionsFromResults, subscribeCompetitionsFromResults } from "../utils/firestore";
import { useCallback, useEffect, useState } from "react";

export const useCompetitions = () => {
  const [competitions, setCompetitions] = useState<CompetitionWithId[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refreshData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await findCompetitionsFromResults();
      setCompetitions(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Wystąpił błąd");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    setError(null);

    const unsubscribe = subscribeCompetitionsFromResults(
      (data) => {
        setCompetitions(data);
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
    );

    return () => unsubscribe();
  }, []);

  return { competitions, loading, error, refreshData };
};
